var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 59,
    viewBox: "0 0 47 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#ACBEC7",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M35.859 48.066L44.578 56.785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.509 4.926H8c-.828 0-1.578.336-2.121.878C5.336 6.347 5 7.097 5 7.926v44c0 .828.336 1.578.879 2.121.543.543 1.293.879 2.121.879h32c.828 0 1.578-.336 2.121-.879.543-.543.879-1.293.879-2.121V20.379c0-.797-.317-1.562-.882-2.124L29.627 5.8c-.562-.56-1.324-.875-2.118-.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.748 13.926V4c0-2.21-1.79-4-4-4H4C1.79 0 0 1.79 0 4v41.944c0 2.21 1.79 4 4 4h.82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 39.926,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M23 37.926L27 37.926M23 41.926L33 41.926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 5.027v11.899c0 1.104.895 2 2 2h12.792"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDetail);
export default __webpack_public_path__ + "static/media/document-detail.da28daa7.svg";
export { ForwardRef as ReactComponent };